import { Input, InputNumber } from 'antd';
import type { InputProps } from 'antd/es/input';
import type { InputNumberProps } from 'antd/es/input-number';
import type { PasswordProps } from 'antd/es/input/Password';
import type { SearchProps } from 'antd/es/input/Search';
import type { TextAreaProps } from 'antd/es/input/TextArea';
import React, { forwardRef } from 'react';

type InputType =
  | 'textarea'
  | 'number'
  | 'search'
  | 'password'
  | 'otp'
  | 'default';

type CommonProps = {
  label?: string;
  type?: InputType;
  floating?: boolean;
  className?: string;
};

type InputCustomProps =
  | (CommonProps & InputProps & { type?: 'default' | undefined })
  | (CommonProps & TextAreaProps & { type: 'textarea' })
  | (CommonProps & PasswordProps & { type: 'password' })
  | (CommonProps & SearchProps & { type: 'search' })
  | (CommonProps & InputNumberProps & { type: 'number' })
  | (CommonProps & Record<string, any> & { type: 'otp' });

const InputCustom = forwardRef<any, InputCustomProps>((props, ref) => {
  const {
    label = '',
    type = 'default',
    floating = false,
    className = '',
    ...rest
  } = props as any;

  const typeMap: Record<string, any> = {
    textarea: Input.TextArea,
    number: InputNumber,
    search: Input.Search,
    password: Input.Password,
    otp: (Input as any).OTP, // nếu có
    default: Input,
  };

  const Component = typeMap[type] || Input;
  let style: React.CSSProperties = rest.style || {};

  if (type === 'textarea') {
    style = {
      ...style,
      minHeight: '80px',
      overflowX: 'hidden',
      overflowY: 'auto', // hoặc 'hidden' tùy nhu cầu
    };
  } else if (type === 'number') {
    style = { ...style, width: '100%' };
  }

  return (
    // chuyển tiếp ref xuống component antd tương ứng
    <Component
      ref={ref}
      placeholder={label}
      className={`${floating ? 'floating-label' : ''} ${className}`}
      {...(type === 'search' ? { enterButton: true } : {})}
      {...rest}
      style={style}
    />
  );
});

InputCustom.displayName = 'InputCustom';
export default InputCustom;
